import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { useCampaign } from '../../context/CampaignContext';

export const MainLayout = ({ children, showSidebar = true, fluid = false }) => {
  const { campaignId } = useParams();
  const { fetchCampaign, currentCampaign, setCurrentCampaign } = useCampaign();

  useEffect(() => {
    if (campaignId && (!currentCampaign || currentCampaign.id !== campaignId)) {
      fetchCampaign(campaignId).catch(console.error);
    }
    
    // Clear current campaign when leaving campaign context
    return () => {
      if (!campaignId) {
        setCurrentCampaign(null);
      }
    };
  }, [campaignId, currentCampaign, fetchCampaign, setCurrentCampaign]);

  return (
    <div className="min-h-screen bg-background noise-overlay">
      <Navbar />
      <div className="flex relative z-10">
        {showSidebar && <Sidebar campaignId={campaignId} />}
        <main className="flex-1 min-h-[calc(100vh-4rem)] flex flex-col">
          {fluid ? (
            // Full-width, no padding — for map/graph pages that need all available space
            <div className="flex-1 flex flex-col min-h-0">
              {children}
            </div>
          ) : (
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
              {children}
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
